// extracted by mini-css-extract-plugin
export var loadingSpinner = "_23-0";